module.exports = __webpack_public_path__ + "static/img/10019 (5).af53548.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (5).webp
// module id = G9xy
// module chunks = 14